// @flow

import _ from "lodash";
import * as React from "react";
import {
  Label,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from "recharts";

import type { UserTask } from "../../data/user-results";

import { bidirectionalEma } from "../../utils";

import "./HistoricalErrorPlot.css";

function taskToDate(task): ?Date {
  if (!task.results) {
    return null;
  }
  return _.last(task.results).createdAt;
}

function taskToError(task): ?number {
  if (!task.results) {
    return null;
  }
  const finalResult = _.last(task.results);
  if (finalResult.kind === "timeout") {
    return null;
  }
  const err = (_.toNumber(task.answer) * 100 - finalResult.confidence) / 100;
  return err;
}

type Props = {
  tasks: Array<UserTask>
};

const HistoricalErrorPlot = (props: Props) => {
  const squaredErrors = _(props.tasks)
    .sortBy(taskToDate)
    .map(taskToError)
    .filter(x => x !== null)
    .map(x => x * x)
    .value();

  const movingAverageSquaredErrors = bidirectionalEma(squaredErrors, 0.2);

  const data = squaredErrors.map((squaredError, i) => ({
    question: i + 1,
    squaredError: _.round(squaredError, 3),
    movingAverageSquaredError: _.round(movingAverageSquaredErrors[i], 3)
  }));
  return (
    <div className="HistoricalErrorPlot">
      <div className="HistoricalErrorPlot-Chart">
        <LineChart
          width={700}
          height={320}
          data={data}
          margin={{ top: 5, right: 30, left: 25, bottom: 15 }}
        >
          <XAxis dataKey="question">
            <Label value="Question" position="insideBottomRight" offset={-10} />
          </XAxis>
          <YAxis>
            <Label value="Error²" position="insideLeft" offset={-15} />
          </YAxis>
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="movingAverageSquaredError"
            stroke="rgb(41, 95, 144)"
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="squaredError"
            stroke="#ffffff"
            strokeWidth={0}
            activeDot={{ stroke: "rgb(41, 95, 144)", strokeWidth: 2 }}
            dot={{ stroke: "rgb(41, 95, 144)", strokeWidth: 2 }}
          />
        </LineChart>
      </div>
    </div>
  );
};

export default HistoricalErrorPlot;



// WEBPACK FOOTER //
// ./src/components/HistoricalErrorPlot/HistoricalErrorPlot.js